// extracted by mini-css-extract-plugin
module.exports = {"container":"stageSelector_container__ze-E_","stageLabel":"stageSelector_stageLabel__1fWnU","input":"stageSelector_input__3Fj-D"};